
interface PageSEO {
  title: string;
  description: string;
  keywords?: string;
  ogImage?: string;
  ogType?: string;
}

interface ServiceSEO extends PageSEO {
  serviceSchema: {
    name: string;
    description: string;
    provider: string;
  }
}

interface SEOConfig {
  home: PageSEO;
  about: PageSEO;
  services: PageSEO;
  shop: PageSEO;
  booking: PageSEO;
  nocode: PageSEO;
  servicesPages: {
    [key: string]: ServiceSEO;
  }
}

export const seoConfig: SEOConfig = {
  home: {
    title: "Build MPVs, Web Apps, Internal Tools Faster, Cheaper and Better.",
    description: "Build MPVs, Web Apps, Internal Tools Faster, Cheaper and Better.",
    keywords: "ai web apps, internal tools, custom software development, web application development, business automation",
    ogImage: "/lovable-uploads/6199980b-2959-40aa-b400-2904c4e09b32.png",
    ogType: "website"
  },
  about: {
    title: "Who We Are | AI-Focused Software Development Agency | LovaBuild",
    description: "Meet the team behind LovaBuild. We're a passionate group of developers, designers and AI specialists creating innovative digital solutions.",
    keywords: "software development agency, ai specialists, web development company, custom software team",
    ogImage: "/lovable-uploads/6199980b-2959-40aa-b400-2904c4e09b32.png"
  },
  services: {
    title: "Our Services | AI Web Apps & Custom Software Development | LovaBuild",
    description: "Explore our range of services including web applications, internal tools, AI integration, UI/UX design, and more.",
    keywords: "web application development, internal tools development, ai integration, ui ux design, software development services",
    ogImage: "/lovable-uploads/6199980b-2959-40aa-b400-2904c4e09b32.png"
  },
  shop: {
    title: "Shop | Ready-to-Use Software Solutions | LovaBuild",
    description: "Browse our collection of ready-to-use software solutions, templates, and components to accelerate your project.",
    keywords: "software solutions, web templates, development components, ready to use software",
    ogImage: "/lovable-uploads/6199980b-2959-40aa-b400-2904c4e09b32.png"
  },
  booking: {
    title: "Book a Consultation | LovaBuild",
    description: "Schedule a free consultation to discuss your project needs with our expert team.",
    keywords: "book consultation, free software consultation, project discussion, web development consultation",
    ogImage: "/lovable-uploads/6199980b-2959-40aa-b400-2904c4e09b32.png"
  },
  nocode: {
    title: "NoCode Mastery | AI-Powered No-Code Training",
    description: "Learn how to build web apps, websites, and SaaS products with AI-powered no-code tools in just a few minutes!",
    keywords: "no-code tools, ai website builder, no-code development, website building training, saas without coding",
    ogImage: "/images/nocode-mastery-og.png"
  },
  servicesPages: {
    webApplications: {
      title: "Web Applications | Custom Software Development | LovaBuild",
      description: "Custom web application development services to transform your ideas into powerful, scalable, and user-friendly digital solutions.",
      keywords: "web application development, custom web app, progressive web applications, enterprise web applications",
      serviceSchema: {
        name: "Web Application Development",
        description: "Custom web applications tailored to your business needs with responsive design and modern technologies.",
        provider: "LovaBuild"
      }
    },
    internalTools: {
      title: "Internal Tools | Custom Software for Business Efficiency | LovaBuild",
      description: "Build internal tools that streamline operations, automate workflows, and improve team productivity.",
      keywords: "internal tools development, business automation, workflow optimization, custom admin panels",
      serviceSchema: {
        name: "Internal Tools Development",
        description: "Custom internal tools and dashboards to improve efficiency and automate business processes.",
        provider: "LovaBuild"
      }
    },
    aiIntegration: {
      title: "AI Integration | Artificial Intelligence Solutions | LovaBuild",
      description: "Leverage the power of artificial intelligence to automate processes, gain insights, and create smarter applications.",
      keywords: "ai integration, artificial intelligence development, machine learning integration, ai solutions",
      serviceSchema: {
        name: "AI Integration Services",
        description: "Integration of artificial intelligence capabilities into your existing software and processes.",
        provider: "LovaBuild"
      }
    },
    design: {
      title: "UI/UX Design | User Experience & Interface Design | LovaBuild",
      description: "Intuitive, visually stunning interfaces that delight your users while achieving your business objectives.",
      keywords: "ui ux design, user interface design, user experience, web design services",
      serviceSchema: {
        name: "UI/UX Design Services",
        description: "Professional user interface and user experience design for web and mobile applications.",
        provider: "LovaBuild"
      }
    }
  }
};
